import { defineComponent, ref, watch, onMounted, onUnmounted } from "vue";
import MemberInfo from "../MemberItemCommon/MemberInfo.vue.mjs";
import MemberControl from "../MemberControl/index.mjs";
import useMemberItem from "./useMemberItemHooks.mjs";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexH5",
  props: {
    userInfo: null
  },
  setup(__props) {
    const props = __props;
    const memberItemContainerRef = ref();
    const { isMemberControlAccessible, openMemberControl, closeMemberControl } = useMemberItem(props.userInfo);
    const showMemberControl = ref(false);
    watch(isMemberControlAccessible, (accessible) => {
      if (accessible === false) {
        showMemberControl.value = false;
      }
    });
    const handleOpenMemberControl = (event) => {
      event.stopPropagation();
      openMemberControl();
      if (isMemberControlAccessible.value === true) {
        showMemberControl.value = true;
      }
    };
    const handleDocumentTouchend = (event) => {
      var _a;
      if ((_a = memberItemContainerRef.value) == null ? void 0 : _a.contains(event == null ? void 0 : event.target)) {
        return;
      }
      closeMemberControl();
      showMemberControl.value = false;
    };
    onMounted(() => {
      document.addEventListener("touchend", handleDocumentTouchend);
    });
    onUnmounted(() => {
      document.removeEventListener("touchend", handleDocumentTouchend);
    });
    return { __sfc: true, props, memberItemContainerRef, isMemberControlAccessible, openMemberControl, closeMemberControl, showMemberControl, handleOpenMemberControl, handleDocumentTouchend, MemberInfo, MemberControl };
  }
});
export {
  _sfc_main as default
};
